module.exports = "../../app/cells/components/modals/setup_wizard/phone.erb";